{
  "iframeWaitingMessage": "感谢您的耐心等待。即将处理完毕...",
  "otherOrganizations": "其他组织",
  "solutionIframe": "主要内容",
  "unloadPromptMessage": "是否确定？"
}
